import api from './api';

const vendorService = {
  getAllVendors: async () => {
    const response = await api.get('/api/vendors');
    return response.data;
  },

  createVendor: async (data) => {
    const response = await api.post('/api/vendors', data);
    return response.data;
  },

  updateVendor: async (id, data) => {
    const response = await api.put(`/api/vendors/${id}`, data);
    return response.data;
  },

  deleteVendor: async (id) => {
    const response = await api.delete(`/api/vendors/${id}`);
    return response.data;
  },

  getCreditExpendituresByVendor: async (vendorId) => {
    const response = await api.get(`/api/vendors/${vendorId}/credit-expenditures`);
    return response.data;
  },

  getPaymentsByVendor: async (vendorId) => {
    const response = await api.get(`/api/vendors/${vendorId}/payments`);
    return response.data;
  },

  createVendorPayment: async (data) => {
    const response = await api.post('/api/vendors/payments', data);
    return response.data;
  },
};

export default vendorService;